import store from '@/store/index.js'

export function addToQueryParameters () {
  const department = store.getters['queryParams/getDepartmentParams']
  const location = store.getters['queryParams/getLocationParams']
  const page = store.getters['queryParams/getPageParam']
  const search = store.getters['queryParams/getSearchParam']
  const team = store.getters['queryParams/getTeamParams']

  // Push query parameters to URL
  const departmentParams = department.length > 0 ? `department=${department.join(';')}` : ''
  const locationParams = location.length > 0 ? `location=${location.join(';')}` : ''
  const pageParams = page !== 1 ? `pageNumber=${page}` : ''
  const searchParams = search !== '' ? `search=${search}` : ''
  const teamParams = team.length > 0 ? `team=${team.join(';')}` : ''
  const allParams = [pageParams, searchParams, locationParams, departmentParams, teamParams];
  let allParamsString = allParams.filter(params => {
    return params.length !== 0
  }).join('&');
  const prependQuestionMark = allParamsString !== '';
  allParamsString = prependQuestionMark ? `?${allParamsString}` : '';

  if (allParamsString === '') {
    const pathWithoutParams = window.location.href.split('?')[0];
    window.history.pushState(null, '', pathWithoutParams)
  } else {
    window.history.pushState(null, '', allParamsString)
  }
}

export function handleDepartmentParameters (departmentParameters) {
  if (!departmentParameters) return

  departmentParameters = departmentParameters.split(';')
  departmentParameters.forEach(department => {
    const departmentParameterData = {
      filter: department,
      category: 'departmentFilters'
    }

    store.commit('filters/addDepartment', departmentParameterData)
  })
}

export function handleLocationParameters (locationParameters) {
  if (!locationParameters) return

  locationParameters = locationParameters.split(';')
  locationParameters.forEach(location => {
    const locationParameterData = {
      filter: location,
      category: 'locationFilters'
    }

    store.commit('filters/addLocation', locationParameterData)
  })
}

export function handleKeywordSearch (keyword) {
  if (!keyword) return

  store.commit('filters/setKeywordSearch', keyword.toLowerCase())
}

export function handlePageNumber (pageNumber) {
  if (!pageNumber) {
    store.commit('pageNumber/setPage', 1)
  } else {
    store.commit('pageNumber/setPage', pageNumber)
  }
}

export function handleTeamParameters (teamParameters) {
  if (!teamParameters) return

  teamParameters = teamParameters.split(';')
  teamParameters.forEach(team => {
    const teamParameterData = {
      filter: team,
      category: 'teamFilters'
    }

    store.commit('filters/addTeam', teamParameterData)
  })
}
